(function (ws) {
    'use strict';

    ws.models.lookupSelectOptionModel = Backbone.Model.extend({

        /** URL */
        url: isQuotingSite ? globals.path.api.quoting.searchAccountManager : globals.path.api.orderentry.orderDetails.searchAccountManager
    });

})(westcon);
